// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> elevation
// Generated: 2026-08-21T22:01:02.267Z
// Counts: 7 design, 40 content, 22 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Elevation, where your new home in Flagstaff, AZ seamlessly blends comfort and adventure. Nestled near cultural gems like the Museum of Northern Arizona and the astounding Walnut Canyon National Monument, enjoy easy access to education at Northern Arizona University. Dive into a lifestyle that celebrates the unique charm of the region!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>Welcome to Elevation, where comfort meets style in Flagstaff, AZ. Choose from spacious one to three-bedroom floor plans, featuring gourmet island kitchens, vaulted ceilings, and pet-friendly amenities. Unwind in our heated pool, savor outdoor cooking, or enjoy scenic mountain views—your perfect home awaits! Explore availability today!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Joy of Living in Your Ideal Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Elevation in Flagstaff, AZ, where modern living meets nature's tranquility. Enjoy our resort-style amenities, from a year-round heated pool and outdoor kitchen to an inviting clubhouse. With pet-friendly spaces, spacious layouts, and stunning mountain views, you'll find your perfect oasis for relaxation and connection.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Lifestyle-Enhancing Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span>At Elevation in Flagstaff, AZ, unique floor plans meet exceptional amenities, enhancing your lifestyle. Enjoy leisurely afternoons at the year-round heated pool, unwind in our spa, or savor outdoor meals at the BBQ grill. With spacious layouts, modern finishes, and breathtaking mountain views, your new home awaits. Lease online today!</span> <span> <span></span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Elevation in vibrant Flagstaff, AZ, we offer thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Reach out to our leasing team today with any questions—you’re just a step away from making your ideal home a reality!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Out to Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Elevation in Flagstaff, AZ, your ideal living space awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that blend comfort and style. Each layout caters to your unique lifestyle. Browse our available apartment homes today and begin crafting the life you've always envisioned.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Elevation in Flagstaff, AZ, your ideal living space awaits. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that blend comfort and style. Each layout caters to your unique lifestyle. Browse our available apartment homes today and begin crafting the life you've always envisioned.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Elevation in Flagstaff, AZ, picture a vibrant lifestyle surrounded by stunning mountain views and modern comforts. From spacious one, two, and three-bedroom apartments featuring sleek cabinetry and open layouts, to resort-style amenities like a heated pool and outdoor kitchen, your dream home awaits. Experience community living at its finest!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments in Flagstaff , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevation</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideally Located in Flagstaff , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime. From Any Distance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome cats and dogs. Breed restrictions apply. (Please call for details.)</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are welcome! Breed restrictions apply.&nbsp;</p><p>Pet Fee: $600 per pet.&nbsp;</p><p>Monthly pet rent: $55 per pet.&nbsp;</p><p>2 pet maximum per apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevate your living experience in Flagstaff at Elevation, where spacious one, two, and three-bedroom floor plans await. Each home is thoughtfully designed to blend comfort and style. Don't just take our word for it—schedule a tour and hear firsthand what our residents love about their vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Tour of Elevation</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule A Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Elevation in Flagstaff, AZ! Our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. A team member will connect with you shortly to help you find your ideal home amidst the majestic backdrop of Flagstaff.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into Elevation, where Flagstaff's charm meets your ideal living space. Our thoughtfully designed one, two, and three-bedroom apartments reflect style and comfort. Embrace the beauty of community life—take a virtual tour to experience your new home today! Your next adventure awaits at Elevation!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Virtual Tour of Our Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans/"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "herocallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour/"
      }
    }
  },
  "herocallouts.cta3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities/"
      }
    }
  },
  "herocallouts.cta4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Browse The Gallery"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery/"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f66a1-c985-77cc-890d-cf6d8b9ad73d.webp"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f777f-c246-734e-bfe7-a58a3c5696b4.webp"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f66a1-cde3-7510-a32b-ca6d870198bb.webp"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f66a1-ca33-76bd-930b-d39427d66a14.webp"
      }
    }
  },
  "parallaxbanner.primary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Visit"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f777f-c69b-767f-8793-20ab93f56198.webp"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f777f-c613-70fd-8c54-7e4c8911d269.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views."
      }
    }
  },
  "socialconnect.image2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f777f-c246-734e-bfe7-a58a3c5696b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table and bar area in the apartment clubhouse lounge."
      }
    }
  },
  "socialconnect.image3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f66a1-c985-77cc-890d-cf6d8b9ad73d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with bar, seating, and string lights overlooking city."
      }
    }
  },
  "socialconnect.image4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166432/019f66a1-ca33-76bd-930b-d39427d66a14.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with plush seating, large tables, and contemporary chandeliers."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
